const INCOMPATIBLE_ALIGN_PATTERN = /(\\(?:begin|end){)(?:align\*?)(})/g;

export const replaceAlignSyntax = formula =>
  // this replace keeps the '\begin{...}\end{...}' the same and only replaces
  // any 'align/align*' at the ... with 'aligned'
  formula.replace(INCOMPATIBLE_ALIGN_PATTERN, '$1aligned$2');

export const removeCancelLoader = formula =>
  formula.replaceAll('\\require{cancel}', '');

const renderWithKatex = formula => {
  const replacedFormula = replaceAlignSyntax(removeCancelLoader(formula));
  if (window.Katex) {
    return window.Katex.renderToString(replacedFormula);
  } else {
    console.error(
      'Katex not loaded for exercises!! Check if you have the pack added in your layout'
    );
    return replacedFormula;
  }
};

export default renderWithKatex;
